import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

function SharedWallet({ theme }) {
  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>
        {t('Wallet')}
      </div>

      <div className="contentDiv noScroll">
        <div className={`tabsDiv ${theme}`}>
          <button
            className={`tabButton ${location.pathname == "/shared_wallet/receipts" ? "active" : ""}`}
            onClick={() => {
                navigate("/shared_wallet/receipts");
            }}
          >
            {t("Receipts")}
          </button>
          <button
            className={`tabButton ${location.pathname == "/shared_wallet/unconfirmed_receipts" ? "active" : ""}`}
            onClick={() => {
              navigate("/shared_wallet/unconfirmed_receipts");
            }}
          >
            {t("Unconfirmed Receipts")}
          </button>
          <button
            className={`tabButton ${location.pathname == "/shared_wallet/bank_accounts" ? "active" : ""}`}
            onClick={() => {
              navigate("/shared_wallet/bank_accounts");
            }}
          >
            {t("Bank Accounts")}
          </button>
        </div>

        <Outlet />
      </div>
    </div>
  );
}

export default SharedWallet;
